export function parseSocketMessage(message) {
  if (!message) {
    return null;
  }

  const raw = typeof message.data === "string" ? message.data : "";
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw);
  } catch (error) {
    try {
      return JSON.parse(raw.replace(/'/g, '"'));
    } catch {
      console.warn("Unable to parse socket payload", raw, error);
      return null;
    }
  }
}
